import BuildingService from '@/service/building'

export default {
    data () {
        return {
            bullet_comments_items: [],
            bullet_comments_total: 0
        }
    },
    methods: {
        async getBulletComments() {
            const { building_id } = this.$route.query
            const { items, total_count } = await BuildingService.getBulletComments(building_id)
            this.bullet_comments_items = items
                .filter(({ content }) => !/^\d+$/.test(content) && content.length > 2)
                .map(item => ({
                    ...item,
                    content: item.content.replace(/[\r\n]/g, '')
                }))
            this.bullet_comments_total = total_count
        }
    }
}
